import { CommodityToolbar } from "~/features/quote/components/quote-details/components/commodity-toolbar/commodity-toolbar.tsx";
import { QuoteCommoditiesWrapper } from "~/features/quote/components/quote-details/components/quote-commodities-wrapper/quote-commodities-wrapper.tsx";

import tenderLtlStyles from "../../index.module.css";
import styles from "./tender-commodities.module.css";

type TenderCommoditiesProps = {
	hideSavedCommodities?: boolean;
	hideSaveCommodity?: boolean;
	itemValidationErrors?: Record<number, Set<string>>;
	onClearItemFieldError?: (itemId: number, fieldKey: string) => void;
	requireClass?: boolean;
};

export const TenderCommodities = ({
	hideSavedCommodities = false,
	hideSaveCommodity = false,
	itemValidationErrors,
	onClearItemFieldError,
	requireClass = true,
}: TenderCommoditiesProps) => {
	return (
		<div
			className={`${styles.tenderCommoditiesWrapper} ${tenderLtlStyles.tenderLtlCard}`}
		>
			<CommodityToolbar hideSavedCommodities={hideSavedCommodities} />

			<QuoteCommoditiesWrapper
				alwaysShowPieceCount
				requireDescription
				requirePieceCountForHazmatOnly
				showHazmatDetails
				hideSaveCommodity={hideSaveCommodity}
				itemValidationErrors={itemValidationErrors}
				mobileAddAnotherUnitLabel={"Add Another Unit"}
				onClearItemFieldError={onClearItemFieldError}
				requireClass={requireClass}
			/>
		</div>
	);
};
